import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ContentChildren,
  HostBinding,
  input,
  output,
  QueryList,
} from '@angular/core';
import { UIUtil } from '@mkp/shared/util-ui';
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component';
import { TabHeaderComponent } from './tab-header/tab-header.component';
import { TabItemComponent } from './tab-item/tab-item.component';
import { TabConfig, TabSize } from './tab.config';

@Component({
  selector: 'mds-tabs',
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [TabHeaderComponent, SkeletonLoaderComponent],
})
export class TabsComponent<TabId, Template = undefined> implements AfterContentInit {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  readonly tabsConfig = input.required<TabConfig>({ alias: 'config' });
  readonly isLoading = input<boolean>(false);
  readonly handleClick = output<TabId>();
  readonly TabSize = TabSize;
  readonly skeletons = computed(() => UIUtil.getNumberedArray(this.tabs?.length ?? 0));

  @ContentChildren(TabItemComponent) tabs!: QueryList<TabItemComponent<TabId, Template>>;

  @HostBinding('class') get headerPaddingClass(): string {
    return this.tabsConfig()?.headerPadding
      ? `header-padding-${this.tabsConfig().headerPadding}`
      : '';
  }

  ngAfterContentInit() {
    this.tabsConfig().showHeader ??= true;

    this.setFirstTabToActiveIfThereIsNoActiveTab();
  }

  selectTab(tabId: TabId) {
    this.tabs.toArray().forEach((tab) => tab.active.set(tab.id() === tabId));

    this.handleClick.emit(tabId);
  }

  private setFirstTabToActiveIfThereIsNoActiveTab(): void {
    const activeTab = this.tabs.toArray().find((tab) => tab.active());
    if (!activeTab) {
      this.tabs.get(0)?.active.set(true);
    }
  }
}
